"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
// Hook that uses a ref to store a reference to the previous value.
function usePrevious(value, initialValue) {
    var ref = React.useRef(initialValue);
    React.useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}
exports.usePrevious = usePrevious;
//# sourceMappingURL=hooks.js.map